/**
 * Extract a parameter value from the current URL's search params
 * @param {string} paramName - The name of the parameter to extract
 * @returns {string|null} - The parameter value or null if not found
 */
export const getURLSearchParam = (paramName) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
};

/**
 * Decode a JWT token and return its payload
 * @param {string} token - The JWT token to decode
 * @returns {object|null} - The decoded payload or null if invalid
 */
export const decodeJWT = (token) => {
    if (!token || typeof token !== 'string') {
        return null;
    }

    try {
        // JWT tokens have 3 parts separated by dots: header.payload.signature
        const parts = token.split('.');
        if (parts.length !== 3) {
            return null;
        }

        // Decode the payload (second part)
        const payload = parts[1];
        
        // Add padding if necessary (base64url doesn't use padding)
        const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);
        
        // Replace URL-safe characters with standard base64 characters
        const base64 = paddedPayload.replace(/-/g, '+').replace(/_/g, '/');
        
        // Decode base64 and parse JSON
        const decodedPayload = JSON.parse(atob(base64));
        
        return decodedPayload;
    } catch (error) {
        console.error('Error decoding JWT:', error);
        return null;
    }
};